import React from 'react';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { AccountIMAPSettings } from './types';
import { InputWrapper } from './styles';

type Props = {
  visible: boolean;
  onClose: () => void | Promise<void>;
  loading: boolean;
  name: string;
  emailAddress: string;
  imap: AccountIMAPSettings;
  setName: (v: string) => void;
  setEmailAddress: (v: string) => void;
  setImap: (updater: any) => void;
  onNext: () => void | Promise<void>;
};

const ImapDialog: React.FC<Props> = ({
  visible, onClose, loading, name, emailAddress, imap, setName, setEmailAddress, setImap, onNext,
}) => (
  <DialogComponent
    visible={visible}
    width="420px"
    isModal
    showCloseIcon
    header="IMAP Zugangsdaten"
    close={onClose}
    buttons={[
      {
        buttonModel: { content: loading ? 'Weiter...' : 'Weiter', isPrimary: true, cssClass: 'e-custom modal-dialog-btn' },
        click: onNext,
      },
    ]}
  >
    <div style={{ padding: 16 }}>
      <InputWrapper>
        <TextBoxComponent 
          value={name} 
          floatLabelType="Auto" 
          placeholder="Name" 
          input={(e: any) => setName(e.value)} 
        />
      </InputWrapper>

      <InputWrapper>
        <TextBoxComponent 
          value={emailAddress} 
          floatLabelType="Auto" 
          placeholder="E-Mail Adresse" 
          input={(e: any) => setEmailAddress(e.value)} 
        />
      </InputWrapper>

      <InputWrapper>
        <TextBoxComponent 
          value={imap.host} 
          floatLabelType="Auto" 
          placeholder="IMAP Host" 
          input={(e: any) => setImap({ ...imap, host: e.value })} 
        />
      </InputWrapper>

      <InputWrapper>
        <TextBoxComponent 
          value={String(imap.port)} 
          floatLabelType="Auto" 
          placeholder="IMAP Port" 
          input={(e: any) => setImap({ ...imap, port: parseInt(e.value, 10) })} 
        />
      </InputWrapper>

      <InputWrapper>
        <DropDownListComponent 
          dataSource={['ssl', 'tls', 'starttls', 'none']} 
          value={imap.secure} change={(e: any) => setImap({ ...imap, secure: e.value })} 
        />
      </InputWrapper>

      <InputWrapper>
        <DropDownListComponent 
          dataSource={['password', 'oauth2']} 
          value={imap.auth_method} 
          change={(e: any) => setImap({ ...imap, auth_method: e.value })} 
        />
      </InputWrapper>

      <InputWrapper>
        <TextBoxComponent 
          value={imap.username} 
          floatLabelType="Auto" 
          placeholder="IMAP Benutzername" 
          input={(e: any) => setImap({ ...imap, username: e.value })} 
        />
      </InputWrapper>

      <InputWrapper>
        <TextBoxComponent 
          type="password" 
          value={imap.password || ''} 
          floatLabelType="Auto" 
          placeholder="IMAP Passwort" 
          input={(e: any) => setImap({ ...imap, password: e.value })} 
        />
      </InputWrapper>
    </div>
  </DialogComponent>
);

export default ImapDialog;
